<template>
  <div class="filter-price filter" >
    <button class="filter-btn icon-caret-down" :class="{ open: open }" @click="toggleFilter()" >{{ getLabel }}</button>

    <div class="toggle-popup" :class="{ open: open }" >
      <div class="filter__header">
        <label>{{ description }}</label>
      </div>
      <div class="filter__body">
        <div class="filter-field filter-field__range">
          <div class="d-flex justify-content-between">
            <span class="range-value">{{ input[0] }}</span>
            <span class="range-value">{{ input[1] }}</span>
          </div>
          <div class="range-wrapper">
            <vue-slider
                ref="slider"
                v-model="input"
                :enable-cross="false"
                :tooltip="'none'"
                :min="min"
                :max="max"
                :interval="steps"
            >
            </vue-slider>
          </div>
        </div>
      </div>
      <div class="filter__footer">
        <button @click="clearFilter()" class="delete-filter">Wissen</button>
        <button @click="setFilter()" class="submit-filter">Toepassen</button>
      </div>
    </div>
  </div>
</template>


<script>



  import VueSlider from 'vue-slider-component'
  import 'vue-slider-component/theme/antd.css'



  export default {
    props: {
      value: {
        type: Array,
      },
      name: {
        type: String,
        default: ''
      },
      label: {
        type: String,
        default: ''
      },
      description: {
        type: String,
        default: ''
      },
      unit: {
        type: String,
        default: ''
      },
      min: {
        type: Number,
        default: 0
      },
      max: {
        type: Number,
        default: 100
      },
      open: {
        type: Boolean,
        default: false,
      }
    },
    data() {
      return {
        timer: null,
        input: this.value
      }
    },
    components: {
      VueSlider
    },

    mounted() {
      // set the filter to min and max so nothing gets filtered
      //this.input = [this.min, this.max]
    },



    computed: {
      // When the filter is set, show the values otherwise show the default label
      getLabel () {
        if(this.input[0] === this.min && this.input[1] === this.max) {
          return this.label
        }
        return  this.unit + ': ' + this.input[0] + ' - ' + this.input[1]
      },
      steps () {
        let diff = this.max - this.min
        if(diff < 10){
          return 1
        }
        return diff / 10
      }
    },
    watch: {
      // every time the value (v-model) changes, update the internal input value so we know what happens
      value (val) {
        this.input = val
      },
      // make sure the v-model gets updated
      input(val) {
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          this.$emit('input', val);
        }, 500)
      }
    },
    methods: {
      // toggle the visibility of the filter
      toggleFilter(){
        if(this.open){
          this.$parent.hideFilter()
        } else {
          this.$parent.showFilter(this.name)
        }
      },
      hideFilter () {
        this.$parent.hideFilter()
      },
      setFilter() {
        this.$parent.setFilters()
        this.toggleFilter()
      },
      // set the range to min and max so nothing gets filtered
      clearFilter () {
        this.input = [this.min, this.max]
        this.toggleFilter()
      },
    }
  }
</script>
